// removed by extract-text-webpack-plugin
module.exports = {"input-select":"input-select--Kfd7E","disabled":"disabled--2F6eI","error":"error--1jo7R","error-message":"error-message--BMkhp","select-wrapper":"select-wrapper--3R2nc","label":"label--3taD2"};


//////////////////
// WEBPACK FOOTER
// ./client/components/input-select/input-select.scss
// module id = 486
// module chunks = 0